import { Button, Card, CardHeader, Spinner, Typography } from '@material-tailwind/react'
import React, { Fragment, useState,useEffect } from 'react'

import { useShared } from '../../../hooks/useShared';
import { useForm } from 'react-hook-form';
import AInput from '../../../components/fields/AInput';
import AIcon from '../../../components/partials/AIcon';
import ASelect from '../../../components/fields/ASelect';
import APDate from '../../../components/fields/APDate';
import ExportReport from '../../../components/reports/ExportReport';


const searchInputFields = [
    { label: 'شــرکت', name: 'sCompany', type: 'select', roles: [1, 2, 28], icon: 'text-outline', className: '!md:col-span-3', options: [] },
    { label: 'کشور مقصد', name: 'shipping_state', type: 'select', roles: [1, 2, 4, 28], icon: 'text-outline', className: '!md:col-span-3', options: [] },
    { label: 'تاريخ صدور', name: 'shipping_date', type: 'pdate', roles: [1, 2, 4, 28], icon: 'text-outline', className: 'md:col-span-2', },
    { label: 'سال صدور', name: 'shipping_year', type: 'pdate', roles: [1, 2, 4, 28], icon: 'text-outline', className: 'md:col-span-2',onlyYear: true, render: true  },
    { label: ' طريقه صدور', name: 'export_type', type: 'select', roles: [1, 2, 4, 28], icon: 'text-outline', className: 'md:col-span-2', 
    options: [
        { value: 1, label: "زمينی", name: 'land' },
        { value: 1, label: "هوايی", name: 'air' },
    ]},

];

export default function ExportReportScreen() {

    const { http, com,setCountries } = useShared()
    const { register, handleSubmit, control, formState: { errors }, reset, setValue } = useForm({});
    const [errorMessage, setErrorMessage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [searchFields, setSearchFields] = useState([...searchInputFields])
    const [exports, setExports] = useState([])
    const [generateExcel, setGenerateExcel] = useState(false)


     //get all companies
     const getCompanyies = () => {
        console.log("getCompanyies ")
      
        if (searchFields[1].options?.length === 0) {
            setLoading(true)
          if (com?.isRole([1,2,28])) {
                http.get(`/api/companies?nameId=true`).then(res => {
                    console.log('get companies ', res);
                    if (res.data?.success) {
                        const data  = res?.data?.data
                        searchFields[0].options =data
                        setSearchFields(searchFields)
                    }
                    setLoading(false)
                })
            }
        }
    }

    useEffect(() => {
        getCompanyies()
        if(  searchFields[1].options?.length===0)
        searchFields[1].options = setCountries()
        setSearchFields(searchFields)
    }, [])

    const submit = (data) => {
        setGenerateExcel(false)
        setLoading(true)
        setExports([])
        setErrorMessage(null)
        data.shipping_year = com.dateConvert(data?.shipping_year)
        data.shipping_date = com.dateConvert(data?.shipping_date)
        http.post(`api/getExportsReport`, data).then(res=>{
            console.log(res);
            if(res?.data?.success){
                if(res?.data?.data?.length===0)   setErrorMessage("There is no any record!")
                setExports(res?.data?.data)
                setGenerateExcel(true)
            }
            setLoading(false)
        },err=>{
            setErrorMessage(err)
            setLoading(false)
        })
    }


    return (
        <div>
            <Card className="w-full p-2 md:p-4 mt-4 relative">
                <div className='flex justify-between border-b pb-2'>
                    <p className="text-sm text-main-color font-bold ">صادرات</p>
                </div>


                <form className=" flex flex-col gap-4 mt-4" onSubmit={handleSubmit(submit)}>


                    <div className='grid md:grid-cols-6 gap-4'>
                        {
                            searchFields?.map((data, i) => {
                                return (
                                  

                                        <div key={i} className={`grid col-span-3  ${data?.className}`}>
                                            {
                                                data?.type === 'text' || data?.type === 'textarea' ?
                                                    <AInput v={{ register, errors, data }} />
                                                    : data?.type === 'select' ? <ASelect v={{ register, errors, control, data, type: "search" }} />
                                                        : data?.type === 'pdate' ? <APDate v={{ register, errors, setValue, control, data, type: "search" }} />
                                                            : null

                                            }
                                        </div>

                                   
                                )
                            })
                        }
                        {/*    <UploadPhoto v={{ obj: null, className: "md:hidden " }} /> */}
                    </div>

                    {errorMessage && <Typography
                        variant="small"
                        color="gray"
                        className="flex items-center text-red-500 gap-2 font-normal "
                    >
                        <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                        {errorMessage}
                    </Typography>}
                    <div className='flex gap-4 md:justify-end'>
                        <Button className="btn1 w-full md:w-[20%]" size='sm' type="submit" disabled={loading}>  {loading ? <Spinner color="teal" className="h-4 w-4" /> : "Generate"}    </Button>

                    </div>


                </form>
              {generateExcel &&  <ExportReport v={{generateExcel,setGenerateExcel,exports}} />}
            </Card>
        </div>
    )
}
